import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { Background, Button, Confirm, Topbar } from '@/components'
import { useStoreActions, useStoreState } from '@/stores'
import { RedeemProduct } from '@/stores'
import { Icons } from '@/assets'
import { useAuth } from '@/routes/use_auth'
import { cn } from '@/utils'

export const QuestRewardsDetail = () => {
  const { id } = useParams()
  const location = useLocation()

  const { collab } = useAuth()

  const item: RedeemProduct = location?.state?.item

  const { fetch } = useStoreActions(action => action.profile)
  const { fetch: fetchProfile } = useStoreActions(action => action.collab.profile)

  const { detail } = useStoreState(state => state.collab.product)
  const { fetchDetail } = useStoreActions(action => action.collab.product)

  const { loading, success } = useStoreState(state => state.collab.redeem)
  const { submit } = useStoreActions(action => action.collab.redeem)

  const { setTitle, setMessage, present } = useStoreActions(action => action.message)

  const [confirm, setConfirm] = useState<boolean>(false)

  useEffect(() => {
    if (!item && collab) fetchDetail(Number(id))
  }, [item, collab, fetchDetail, id])

  const redeem = () => {
    setConfirm(false)
    if (item?.source?.toLowerCase() === 'internal') {
      const data = {
        products: [{ id: item?.id, qty: 1 }]
      }
      submit(data)
    }
  }

  useEffect(() => {
    if (success) {
      setTitle('Redeem')
      setMessage('Congratulations! You\'ve got the voucher!\nCheck it out in my reward menu and use it ASAP before it expires!')
      present()
      fetch()
      fetchProfile()
    }
  }, [success, fetch, fetchProfile, present, setMessage, setTitle])

  const Image = ({ item }: { item: RedeemProduct }) => {
    const [error, setError] = useState<boolean>(false)

    if (error || !item?.images?.[0])
      return (
        <div
          className="flex justify-center items-center aspect-square bg-[#f5f5f5] animate-fade"
        >
          <img
            className="h-10 opacity-20"
            src={Icons.image_break}
            alt="icon"
          />
        </div>
      )

    return (
      <div
        className="aspect-square bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${item?.images?.[0]})` }}
      >
        <img
          className="hidden"
          src={item?.images?.[0]}
          onError={() => setError(true)}
          alt="outlet"
        />
      </div>
    )
  }

  const data = detail || item

  return (
    <div>
      <Background collab />
      <div
        className={cn(
          "flex flex-col bg-white bg-opacity-30 min-h-screen",
          "min-h-dvh"
        )}
      >
        <div className="flex flex-1 flex-col">
          <Topbar collab />
          <div className="flex-1">
            <Image item={data} />
            <div className="p-4">
              <div className="font-outfit font-semi-bold text-sm text-black/70">
                {data?.name}
              </div>
              <div className="font-outfit font-bold text-lg text-[#7a5020]">
                {data?.point} Stamps
              </div>
              <div className="font-outfit font-medium text-sm text-black/70 mt-2">
                Available at: {data?.available_stores?.length > 0 ? data?.available_stores?.map(item => item.store_name).join(', ') : 'All Outlets'}
              </div>
              {data?.note &&
                <div className="font-outfit font-medium text-sm text-black/70 mt-2"
                  dangerouslySetInnerHTML={{ __html: data?.note }}
                />
              }
              {data?.instructions &&
                <div className="font-outfit font-medium text-sm text-black/70 mt-2"
                  dangerouslySetInnerHTML={{ __html: data?.instructions }}
                />
              }
              {data?.terms &&
                <div className="font-outfit font-medium text-sm text-black/70 mt-2"
                  dangerouslySetInnerHTML={{ __html: data?.terms }}
                />
              }
            </div>
          </div>
          <div className="p-4">
            <Button
              className="bg-[#7a5020]"
              label="Redeem"
              onClick={() => setConfirm(true)}
              disabled={!collab}
              loading={loading}
            />
          </div>
        </div>
      </div>
      {confirm &&
        <Confirm
          title="Are you sure to redeem your stamp?"
          content=""
          onConfirm={redeem}
          onCancel={() => setConfirm(false)}
        />
      }
    </div>
  )
}
